<template>
  <v-dialog v-if="value" v-model="value" persistent max-width="900px">
    <v-card>
      <v-toolbar flat>
        <span class="headline">Copy Loan</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <ValidationObserver ref="targetPortfolioObserver" v-slot="{ validate, reset }">
              <ValidationProvider name="Target Portfolio" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="layouts.data.targetPortfolio"
                  label="Target Portfolio"
                  hide-details="auto"
                  :error-messages="errors[0]"
                  :items="layouts.data.targetPortfolioArray"
                ></v-select>
              </ValidationProvider>
            </ValidationObserver>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <strong class="f-s-16">History</strong>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="layouts.settings.headers"
              :items="layouts.data.historyArray"
              hide-default-footer
            >
              <template v-slot:item.region="{ item }">
                {{ assets.tool.getEnumTextByValue(assets.dataType.SystemRegionEnum, item.region) }}
              </template>
              <template v-slot:item.sourcePortfolioId="{ item }">
                {{ getPortfolio(item.sourcePortfolioId) }}
              </template>
              <template v-slot:item.targetPortfolioId="{ item }">
                {{ getPortfolio(item.targetPortfolioId) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="footer">
        <v-spacer></v-spacer>
        <v-btn color="primary" text :loading="layouts.loading.copyLoan" @click="onClickCopy">Copy</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DataType, Tool, Popup, Cache, Crypto } from '@/util/index'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { OriginationBusinessApi, OriginationApi, RuntimeApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
const cache = new Cache()
export default {
  name: 'copy-loan',
  inject: ['reload'],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loan: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      assets: {
        tool: new Tool(),
        dataType: DataType
      },
      layouts: {
        settings: {
          headers: [
            { text: 'Source System', value: 'region', sortable: false },
            { text: 'Source Loan #', value: 'sourceLoanNo', sortable: false },
            { text: 'Source Portfolio', value: 'sourcePortfolioId', sortable: false },
            { text: 'Target Loan #', value: 'targetLoanNo', sortable: false },
            { text: 'Target Portfolio', value: 'targetPortfolioId', sortable: false }
          ]
        },
        data: {
          historyArray: [],
          targetPortfolio: null,
          targetPortfolioArray: [],
          totalPortfolioArray: []
        },
        loading: {
          copyLoan: false
        }
      }
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.initHistory()
        this.listPortfolio()
      }
    }
  },
  mounted () {},
  methods: {
    initHistory () {
      const $this = this
      $this.layouts.data.historyArray = []
      const request = {
        loanId: $this.loan.id,
        feature: 'EXPRESSED_RECORD'
      }
      OriginationApi.listSectionFeature(request, function (result) {
        $this.layouts.data.historyArray = result
      })
    },
    onClickCopy () {
      const $this = this
      $this.$refs.targetPortfolioObserver.validate().then(result => {
        if (result) {
          $this.layouts.loading.copyLoan = true
          const request = {
            sourceLoanId: $this.loan.id,
            targetPortfolioId: $this.layouts.data.targetPortfolio
          }
          OriginationBusinessApi.copyLoan(request, function (result) {
            $this.layouts.loading.copyLoan = false
            $this.$emit('hideDialog')
            $this.hideDialog()
            cache.setSessionLoanId(Crypto.encrypt(result))
            window.localStorage.removeItem('searchKey')
            $this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.AUTOMATIC_LOCK.value)
            if ($this.$route.path.includes('/pre-origination/application') && !$this.$route.path.includes('/queue')) {
              $this.reload()
            } else {
              $this.$router.push('/pre-origination/application')
            }
          }, function (result) {
            $this.layouts.loading.copyLoan = false
            popup.popupForError(result.message)
          })
        }
      })
    },
    listPortfolio () {
      const $this = this
      const portfolioId = this.loan.portfolioId
      this.layouts.data.targetPortfolioArray = []
      RuntimeApi.sameTribePortfolio({ portfolioId: this.loan.portfolioId }, function (result) {
        if (tool.isNotEmpty(result)) {
          for (let item of result) {
            if (typeof item === 'string') {
              item = JSON.parse(item)
              if (tool.isNotEmpty(item) && portfolioId !== item.portfolioId) {
                $this.layouts.data.targetPortfolioArray.push({ value: item.id, text: item.portfolioName })
              }
            }
          }
        }
      }, function () {
        $this.layouts.data.targetPortfolioArray = []
      })

      RuntimeApi.listPortfolioByCompanyId(function (result) {
        const portfolioArray = []
        if (tool.isNotEmpty(result)) {
          for (let item of result) {
            if (typeof item === 'string') {
              item = JSON.parse(item)
            }
            portfolioArray.push(item)
          }
          $this.layouts.data.totalPortfolioArray = portfolioArray
        }
      }, function () {
        $this.layouts.data.totalPortfolioArray = []
      })
    },
    getPortfolio (portfolio) {
      let result = ''
      for (const item of this.layouts.data.totalPortfolioArray) {
        if (item.id === portfolio) {
          result = item.portfolioName
        }
      }
      return result
    },
    hideDialog () {
      this.$emit('change', false)
      const $this = this
      $this.layouts.data.targetPortfolio = null
      $this.layouts.data.targetPortfolioArray = []
    }
  }
}
</script>
